import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CampusProofCard} from '../ProofEdit/CampusProofCard';
import {CampusButton} from '../Components/CampusButton';
import {ProductSelector} from '../ProductSelector/ProductSelector';
import {browserHistory} from 'react-router';

/* root for image */
declare var ImageRoot: string;

class ProductProps extends Tgcc.BaseProps {
    product: Tgcc.Product;
}

const imgStyle: React.CSSProperties = {
    maxHeight: '180px',
    maxWidth: '180px',
    height: 'auto',
    width: 'auto',
    alignSelf: 'center',
    display: 'flex'
}

const labelStyle: React.CSSProperties = {
    fontFamily: 'BarlowMedium',
    fontSize: '11px',
    letterSpacing: '1px',
    textTransformm: 'uppercase'
}

const cStyle: React.CSSProperties ={
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    marginTop:'10px'
}
const productText: React.CSSProperties = {
    fontFamily:'BarlowLight',
    color:'#626161',
    width:'75%',
    textAlign:'center',
    margin:'auto auto'
}

const productText1: React.CSSProperties = {
    fontFamily:'BarlowLight',
    color:'#626161',
    width:'75%',
    textAlign:'center',
    margin:'auto'
}

const btnCont: React.CSSProperties = {
    marginTop:'10px'
}
const step: React.CSSProperties = {
    textAlign:'center',
    textTransform:'uppercase',
    fontFamily:'BarlowMedium',
    fontSize:'20px'
}
const optional: React.CSSProperties = {
    color:'#D46F5A',
    fontFamily:'BarlowLight',
}
class _RealCampusProductEdit extends React.Component<ProductProps, Tgcc.GlobalState> {

    openProduct = () => {browserHistory.push(Tgcc.Routes.RealCampusProductListView)}

    handleMissingProductImage = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    }

    getProductImage(){
        if(this.props.product){
            var p = this.props.product;
            var image = Tgcc.getProductPath(this.props.product.thumbnail.replace(' ', '%20'))
            return ( 
                <div style={cStyle}>
                    <img src={image} style={imgStyle} onError={this.handleMissingProductImage}/>
                    <div style={labelStyle}>{p.brand}&nbsp;{p.style}</div>
                    <div style={labelStyle}>{p.colorName}</div>
                </div>
            );
        }
    }
    ifProduct(){
        if(!this.props.product){
            return (
                <div style={productText}>If you don't know what you want yet - leave this blank and our team will reach out.</div>
            )
        }
    }

    render() {
        var btnText: string = this.props.product ? "Change apparel" : "Choose apparel";
        return (
            <div>
                <div style={step}>Step 3</div>
                <CampusProofCard title="APPAREL" fontFamily="BarlowMedium" margin='0px 10px' containerHeight='450px' containerWidth='375px'  innerHeight='380px' innerWidth='335px'>
                    <div style={optional}><i>*this step is optional!</i></div>
                    { this.getProductImage() }
                    {this.ifProduct()}
                    <div style={btnCont}>
                    <CampusButton text={btnText}  onClick={this.openProduct} fontFamily='BarlowMedium' display='flex' alignItems='center' margin='auto' fontSize='15px' backgroundColor='#5E6A74' color='white'/>
                    </div>
                    <div style={productText1}>Don&#39;t see what you need? Upload a screenshot in Step 1!</div>
                </CampusProofCard>
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { product: state.ActiveProof.product }
};

export var RealCampusProductEdit = connect(mapStateToProps)(Radium(_RealCampusProductEdit));